import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import { messageGlobal, messageGagal } from '../../../../../_utils/message';
import { 
   Table, Menu,
   Button,
   Segment, Input, Pagination,
} from 'semantic-ui-react';
import _ from 'lodash';
import ModalDetail from '../../opd/_sts/ModalDetail';
import ExportSTS from './ExportSTS';
import { fetchOPD,fetchSKPD } from '../../../../../_utils/localstorage';

export default class ListSTS extends Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         data: [],
         direction: null,
         requests:true,
         activePage:1,
         totalPages:0,
         q:"",
         is_detail:false,
         data_detail:null,
         loading_detail:false,
         is_export:false,
         pageActive: 1,
      }

      this.searchSts = this.searchSts.bind(this);
      this.onCloseDetail = this.onCloseDetail.bind(this);
      this.onOpenDetail = this.onOpenDetail.bind(this);
      this.onRefresh = this.onRefresh.bind(this);
      this.onCloseExport = this.onCloseExport.bind(this);
      this.onOpenExport = this.onOpenExport.bind(this);
   }

   getDataOPD(){
      fetch(`${BaseURLDev}/simantra/ref/allopd`)
      .then(response => {
         if(!response.ok){
            // messageGagal("Load data SKPD gagal dari SIMDA")            
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         var { skpd, user } = JSON.parse(sessionStorage.data);
         sessionStorage.setItem('data', JSON.stringify({
            user: user,
            opd: resJSON.data,
            skpd: skpd
         }))
      })
   }

   getDataSKPD(){
      fetch(`${BaseURLDev}/simantra/ref/allskpd`)
      .then(response => {
         if(!response.ok){
            // messageGagal("Load data OPD gagal dari SIMDA")            
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         var { opd, user } = JSON.parse(sessionStorage.data);
         sessionStorage.setItem('data', JSON.stringify({
            user: user,
            opd: opd,
            skpd: resJSON.data,
         }))
      })
   }

   onCloseExport = () => this.setState({is_export:false})
   onOpenExport = () => this.setState({is_export:true})

   onOpenDetail = (e, { index }) => this.setState({is_detail:true,data_detail:this.state.data[index]});
   onCloseDetail = () => this.setState({is_detail:false,data_detail:null});

   handleSort = clickedColumn => () => {
      const { column, data, direction } = this.state

      if (column !== clickedColumn) {
         this.setState({
            column: clickedColumn,
            data: _.sortBy(data, [clickedColumn]),
            direction: 'ascending',
         })

         return
      }

      this.setState({
         data: data.reverse(),
         direction: direction === 'ascending' ? 'descending' : 'ascending',
      })
   }

   componentWillMount(){
      if(fetchSKPD().length===0 || fetchOPD().length===0){
         this.getDataSKPD()
         this.getDataOPD()
      }
      fetch(`${BaseURLDev}/sts`, { headers })
      .then(response => {
         if(!response.ok){
            messageGagal("Load data gagal")            
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => (
         this.setState({data:resJSON.data,totalPages:resJSON.totalPage,requests:false})
      ))
      .catch(err => messageGlobal({message:"Load data gagal",option:{refresh:true},value:"/c/realisasi"}))
   }

   handlePaginationChange = (e, { activePage }) => {
      if (this.state.pageActive === activePage){
         return false;
      }

      this.setState({ activePage, pageActive: activePage, requests: true })
      let url = null;
      if(this.state.q!==""){
         url = `${BaseURLDev}/sts?page=${activePage}&q=${this.state.q}`
      }else{
         url = `${BaseURLDev}/sts?page=${activePage}`         
      }
      fetch(url,{headers})
      .then(response => response.json())
      .then(resJSON => (
         this.setState({data:resJSON.data,totalPages:resJSON.totalPage,requests:false})
      ));
   } 

   searchSts(e) {
      this.setState({q:e.target.value});
      if((e.target.value).length > 1 || (e.target.value).length===0){            
         fetch(`${BaseURLDev}/sts?q=${e.target.value}`,{headers})
         .then(response => {
            if(!response.ok){
               messageGagal("Load data gagal")               
               this.setState({data:[],requests:false});
               return Promise.reject(response.statusText);
            }
            return response.json()
         })
         .then(resJSON => (
            this.setState({data:resJSON.data,totalPages:resJSON.totalPage,requests:false})
         ))
         .catch(err => messageGlobal({message:"Terjadi kesalahan",option:{refresh:true},value:"/c/realisasi"}))
      }
   }
   
   onRefresh(){
      this.setState({q:"",requests:true})
      fetch(`${BaseURLDev}/sts`, { headers })
      .then(response => {
         if(!response.ok){
            window.alert("Load data gagal")            
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => (
         this.setState({data:resJSON.data,totalPages:resJSON.totalPage,requests:false})
      ))
      .catch(e => {
         this.setState({
            requests:false,
         })
         window.alert("Server gangguan")
      })
   }

   render() {
      const { column, data, direction,activePage } = this.state;
      return (
         <div>
            <div>                     
               <Menu>
                  <Menu.Item>
                     <Input type="text"
                        icon="search"
                        placeholder="Masukkan Nomor STS"
                        autoFocus 
                        value={this.state.q}
                        style={{width:'300px'}}
                        onChange={this.searchSts} />
                  </Menu.Item>
                  <Menu.Item>                     
                     <Button.Group size='small'>
                        <Button content="Export" disabled={this.state.requests} color='red' icon='download' onClick={this.onOpenExport} />
                        <Button color='blue' disabled={this.state.requests} content="Refresh" icon='refresh' onClick={this.onRefresh} />                        
                     </Button.Group>
                  </Menu.Item>
                  <Menu.Item>
                     <h4>STS yang telah anda verifikasi akan ditampilkan di sini</h4>
                  </Menu.Item>
               </Menu>
               <Segment loading={(this.state.loading_detail || this.state.requests)}>
                  <Table size='small' sortable celled>
                     <Table.Header>
                        <Table.Row>
                           <Table.HeaderCell style={{width:"5%"}}>No.</Table.HeaderCell>
                           <Table.HeaderCell style={{width:"5%",textAlign:"center"}}>#</Table.HeaderCell>
                           <Table.HeaderCell style={{width:"15%"}} sorted={column === 'no_sts' ? direction : null} onClick={this.handleSort('no_sts')}>
                              Nomor STS
                           </Table.HeaderCell>
                           <Table.HeaderCell style={{width:"10%"}} sorted={column === 'created_at' ? direction : null} onClick={this.handleSort('created_at')}>
                              Tanggal STS
                           </Table.HeaderCell>
                           <Table.HeaderCell style={{width:"10%"}} sorted={column === 'updated_at' ? direction : null} onClick={this.handleSort('updated_at')}>
                              Tanggal Verifikasi
                           </Table.HeaderCell>
                           <Table.HeaderCell>Keterangan</Table.HeaderCell>
                        </Table.Row>
                     </Table.Header>
                     <Table.Body>
                        {data.length===0 && 
                           <Table.Row>
                              <Table.Cell colSpan="6">Data tidak ditemukan</Table.Cell>                           
                           </Table.Row>}
                        {_.map(data, (item,i) => (
                           <Table.Row key={i}>   
                              <Table.Cell>
                                 {i+1+(activePage-1)*10}.
                              </Table.Cell>            
                              <Table.Cell style={{width:"5%",textAlign:"center"}}>
                                 <Button
                                    size="mini"
                                    color='blue'
                                    icon='block layout'
                                    index={i}                                          
                                    onClick={this.onOpenDetail}
                                 />
                              </Table.Cell>
                              <Table.Cell>{item.no_sts}</Table.Cell>
                              <Table.Cell>{toDMYDate(item.created_at)}</Table.Cell>
                              <Table.Cell>{
                                 item.tgl_realisasi ? toDMYDate(item.tgl_realisasi) : "Belum terverifikasi"
                              }</Table.Cell>
                              <Table.Cell>{item.keterangan}</Table.Cell> 
                           </Table.Row>
                        ))}
                     </Table.Body>
                     <Table.Footer>
                        <Table.Row>
                           <Table.HeaderCell colSpan='7'>
                              <Pagination activePage={activePage} 
                                 onPageChange={this.handlePaginationChange} 
                                 totalPages={this.state.totalPages}
                              />
                           </Table.HeaderCell>
                        </Table.Row>
                     </Table.Footer>                     
                  </Table>
                  {this.state.is_detail && 
                     <ModalDetail 
                        open={this.state.is_detail}
                        data_detail={this.state.data_detail} 
                        onClose={this.onCloseDetail} />
                  }
                  {this.state.is_export &&
                     <ExportSTS
                        open={this.state.is_export}
                        onClose={this.onCloseExport}
                        data={this.state.data}
                     />
                  }
               </Segment>
            </div>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/bank/_sts/ListSTS.js